module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB5SURBVEhL3c1RCoMwAATRHM2b9Wi9WVKzTJGynx388IHouJCMZ5lzvviMf/vHWus4n+0wupy3v/e630aXPX4ZXdjC6MIWRhc2Dcde+K/h2BtxcRhd2MLowhZGF7YwurCF0YVNw7EX/ms49kZcHEYXtjC6sIXRTzHGB3I1Tzry2axQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-fence/light/24.png
// module id = 2034
// module chunks = 2